import {
  call,
  put,
  getContext,
  fork,
  takeEvery,
  delay,
  select
} from "redux-saga/effects";
import {
  callApi,
  send,
  resolve,
  append,
  reject,
  SEGMENT_MEMBERSHIPS_RECALCULATED
} from "actions/account/segmentMemberships";
import { takeUntil } from "effects/takeUntil";
import { reportError } from "helpers/error-reporting";
import { SYNC_ACCOUNT_WITH_FIREBASE } from "constants/actionTypes";
import { selectSegmentMembershipsComputedAt } from "reducers/account/segmentMemberships";
import { showToast } from "actions/toaster";
import { promisaga } from "utils/as-promised";

export function* fetchSegmentMembership({ payload: { id } }) {
  try {
    const api = yield getContext("api");
    const { data: segmentMembership } = yield call(
      api.getSegmentMembership,
      id
    );
    yield put(append({ [id]: segmentMembership }));
  } catch (e) {
    yield call(reportError, e);
  }
}

export function* fetchAllSegmentMemberships() {
  try {
    yield put(send());
    const api = yield getContext("api");
    const { data: segmentMemberships } = yield call(
      api.getAllSegmentMemberships
    );
    yield put(resolve(segmentMemberships));
  } catch (e) {
    yield call(reportError, e);
    yield put(reject(e));
  }
}

export function* recalculate() {
  try {
    const lastComputedAt = yield select(selectSegmentMembershipsComputedAt);
    const rbf = yield getContext("rbf");
    yield call(rbf.recalculateSegmentMemberships);
    while (
      lastComputedAt === (yield select(selectSegmentMembershipsComputedAt))
    ) {
      yield delay(5000);
      yield call(fetchAllSegmentMemberships);
    }
  } catch (e) {
    yield call(reportError, e);
    yield put(
      showToast({
        type: "error",
        message: "Failed to recalculate Segment Memberships"
      })
    );
  }
}

export default function* () {
  yield takeEvery(SEGMENT_MEMBERSHIPS_RECALCULATED, promisaga(recalculate));
  const action = yield takeUntil(
    action => {
      return callApi(action) && action.payload && action.payload.id;
    },
    fetchSegmentMembership,
    action => callApi(action) && !action.payload
  );
  yield fork(fetchAllSegmentMemberships, action);
  yield takeEvery(SYNC_ACCOUNT_WITH_FIREBASE, fetchAllSegmentMemberships);
}
